<template>
  <div>
    <select class="form-control" @change="onChanged($event)" :style="style">
      <option selected value="0"
        >---{{ $t("messages.general.notSpecified") }}---</option
      >
      <option
        v-for="(item, index) in items"
        :key="index"
        :selected="selectedVal == item"
      >
        {{ item }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MasterDataProvider from "@/services/masterData_provider";

const masterDataProvider = new MasterDataProvider();

export default {
  name: "AcademicYear",
  props: {
    onChanged: Function,
    selectedVal: Number,
    style: {
      type: String,
      default: ""
    }
  },
  data: () => {
    return {
      items: []
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("application", ["togglePreLoader"]),
    async loadData() {
      this.togglePreLoader(true);
      var temp = await masterDataProvider.getAcadyear(this.token);
      temp.sort(function(a, b) {
        return b - a;
      });
      this.items = temp;
      this.togglePreLoader(false);
    }
  },
  watch: {
    currentLang() {
      this.loadData();
    }
  }
};
</script>
